import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faPenToSquare, faSearch } from '@fortawesome/free-solid-svg-icons'
const ProfissionalList = ({ listProfissional, handleDelete, setIsloading, listPermissoes }) => {


    return (
        <>

            {listProfissional.map((item, key) => (
                <tr key={key}>
                    <td>{item.id}</td>
                    <td>{item.nome}</td>
                    <td className="text-center">
                        {(listPermissoes?.ver) ?
                            <Button size="sm" variant="success" onClick={() => setIsloading(true)} href={'/admin/profissionais/ficha/' + item.id} title="Ver ficha" className="mr-10"><FontAwesomeIcon icon={faSearch} /></Button>
                            : ''}
                        {(listPermissoes?.editar) ?
                            <Button size="sm" variant="primary" onClick={() => setIsloading(true)} href={'/admin/profissionais/cadEdit/' + item.id} title="Editar" className="mr-10"><FontAwesomeIcon icon={faPenToSquare} /></Button>
                            : ''}
                        {(listPermissoes?.excluir) ?
                            <Button size="sm" variant="danger" title="Excluir" onClick={() => handleDelete(item.id)}><FontAwesomeIcon icon={faTrash} /></Button>
                            : ''}

                    </td>
                </tr>


            ))}
        </>
    )

}

export default ProfissionalList;